module.exports = __webpack_public_path__ + "images/emoji/man_with_gua_pi_mao.aeea29776bbef1fe4ada.png";